import { Link } from "@tanstack/react-router";

import { useStationPage } from "../components/StationLayout";
import { formatAiring } from "../lib/publicPages";

/**
 * The Shows tab: every show on the station as a card — art, name, DJs, and
 * when it's next on — tiled masonry-style (see .station__cards).
 */
const ShowsList = () => {
  const { stationSlug, directory } = useStationPage();

  if (!directory) {
    return <p className="station__quiet mono">Loading…</p>;
  }
  if (directory.shows.length === 0) {
    return <p className="station__quiet mono">This station has no shows yet</p>;
  }

  return (
    <ul className="station__cards">
      {directory.shows.map((show) => {
        const airing = show.next_airing;
        const onAir = airing && new Date(airing.start) <= new Date();
        return (
          <li key={show.slug} className="station__card">
            <Link
              to="/$stationSlug/shows/$showSlug"
              params={{ stationSlug, showSlug: show.slug }}
            >
              {show.image_url && (
                <img
                  className="station__card-art"
                  src={show.image_url}
                  alt=""
                />
              )}
              <span className="station__card-name">{show.name}</span>
              {show.hosts.length > 0 && (
                <span className="station__card-djs">
                  {show.hosts.map((host) => host.name).join(", ")}
                </span>
              )}
              {airing && (
                <span className="station__card-when mono">
                  {onAir ? (
                    <>
                      <i className="live-dot" /> On air
                    </>
                  ) : (
                    formatAiring(airing.start)
                  )}
                </span>
              )}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default ShowsList;
